module.exports = __webpack_public_path__ + "static/img/GettyImages-697538599.f778fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GettyImages-697538599.jpg
// module id = ZXHE
// module chunks = 0